"use client";

import React from "react";
import { MapPin, Navigation, Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Map() {
  const headerReveal = useRevealOnScroll({
    threshold: 0.1
  });
  const mapReveal = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const cardReveal = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  return <section data-section-id="254943" id="locationmap" className="bg-background text-foreground py-16 md:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        
        {}
        <div ref={headerReveal.ref} className={`text-center max-w-2xl mx-auto mb-12 transition-all duration-1000 ease-out ${headerReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Find Our Sanctuary
          </h2>
          <Separator className="w-24 mx-auto bg-primary h-[1px]" />
          <p className="mt-6 text-muted-foreground font-serif text-xl italic">
            Experience the pinnacle of aesthetics and relaxation at our boutique clinic in the heart of Brooke.
          </p>
        </div>

        {}
        <div ref={mapReveal.ref} className={`relative max-w-5xl mx-auto transition-all duration-1000 delay-200 ease-out ${mapReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="p-2 md:p-3 bg-card border border-border rounded-lg shadow-xl">
            <div className="relative w-full h-[400px] md:h-[500px] lg:h-[600px] rounded-md overflow-hidden bg-muted">
              <iframe src="https://maps.google.com/maps?q=33%20Norwich%20Road,%20Brooke,%20Norwich&hl=en&z=15&output=embed" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Natalia's Beauty Location - Brooke, Norwich" className="absolute inset-0 w-full h-full grayscale-[80%] contrast-[1.05] opacity-95 hover:grayscale-0 hover:opacity-100 transition-all duration-700">
                {}
                <p className="p-4 text-center font-sans text-foreground">
                  33 Norwich Road, Brooke, Norwich NR15 1AB
                </p>
              </iframe>
            </div>
          </div>
        </div>

        {}
        <div ref={cardReveal.ref} className={`max-w-lg mx-auto mt-12 transition-all duration-1000 delay-400 ease-out ${cardReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Card className="bg-card border-border shadow-md overflow-hidden rounded-lg">
            <CardContent className="p-8 text-center flex flex-col items-center">
              <div className="w-16 h-16 rounded-lg bg-primary/20 flex items-center justify-center mb-6">
                <MapPin className="w-8 h-8 text-foreground" />
              </div>
              <h3 className="font-default text-2xl font-semibold text-foreground mb-3 tracking-wider">
                The Clinic
              </h3>
              <p className="text-muted-foreground font-serif text-lg mb-8 leading-relaxed tracking-wide">
                33 Norwich Road, Brooke<br />
                Norwich, NR15 1AB
              </p>
              <div className="flex flex-col sm:flex-row gap-4 w-full justify-center">
                <Button asChild size="lg" className="w-full sm:w-auto font-sans text-sm tracking-widest uppercase bg-primary text-primary-foreground hover:bg-primary/90 rounded-md">
                  <Link to="https://www.google.com/maps/dir/?api=1&destination=33+Norwich+Road+Brooke+Norwich" newTab>
                    <Navigation className="w-4 h-4 mr-2" />
                    Get Directions
                  </Link>
                </Button>
                <Button asChild size="lg" variant="outline" className="w-full sm:w-auto font-sans text-sm tracking-widest uppercase border-primary text-foreground hover:bg-primary/10 rounded-md">
                  <Link to="tel:07766733976">
                    <Phone className="w-4 h-4 mr-2" />
                    Call Us
                  </Link>
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>

      </div>
    </section>;
}